import { CmsRegistrationRoot } from '../cms/cms-registration-root.interface';
import { CmsProtectionBenefitsAccordion } from './cms-protection-benefits-accordion.interface';
import { CmsProtectionDetailsUpsellModal } from './cms-protection-details-upsell-modal.interface';
import { CmsProtectionDetails } from './cms-protection-details.interface';

export interface CmsProtectionDetailsPage
  extends CmsProtectionBenefitsAccordion,
    CmsProtectionDetails,
    CmsRegistrationRoot,
    CmsProtectionDetailsUpsellModal {
  pageTitle: string;
  promotionalPrice: boolean;
  protectionDetailsTermsAndConditions: string;
}
